export type StorePlatform = 'android' | 'ios' | 'windows' | 'macos';

export function detectStorePlatform(userAgent: string, platform: string, maxTouchPoints: number): StorePlatform | null {
  if (/Android/i.test(userAgent)) return 'android';
  if (/iPhone|iPad|iPod/i.test(userAgent) || (platform === 'MacIntel' && maxTouchPoints > 1)) return 'ios';
  if (/Windows/i.test(userAgent)) return 'windows';
  if (/Macintosh|Mac OS X/i.test(userAgent)) return 'macos';
  return null;
}
